import React from 'react';
import PropTypes from 'prop-types';
import {Space} from 'antd';
import {WalletIcon} from '../../../../icons';
import {colorsStyles} from '../../../../utils/styles';
import IconWrapper from '../../../IconWrapper';
import {StyledBalanceDetails} from './StyledBalanceDetails';

const BalanceDetails = ({name, value, ...rest}) => (
  <StyledBalanceDetails {...rest}>
    <Space align='center' size='small'>
      <span>{name}:</span>
      <Space align='center' size='small'>
        <IconWrapper size={24} color={colorsStyles.neutral_10}>
          <WalletIcon />
        </IconWrapper>
        <span className='balance-value'>{value}</span>
      </Space>
    </Space>
  </StyledBalanceDetails>
);

BalanceDetails.propTypes = {
  name: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
};

export default BalanceDetails;
